import moment from 'moment';
import reqwest from 'reqwest';
import settings from '../../../settings';

/**
 * Aufrufe von api/StatisticEvaluation (CARE-814). Antworten sind JSON-Strings
 * mit PascalCase-Feldern, POST-Parameter Formfelder mit JSON-String - wie bei
 * den Textbausteinen.
 */

export const BROKER_UNAVAILABLE =
  'Die Falldaten sind gerade nicht erreichbar. Bitte versuchen Sie es später erneut.';
const SESSION_EXPIRED =
  'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.';

function token() {
  return localStorage.getItem('token');
}

export function parseJson(response) {
  if (typeof response !== 'string') {
    return response === undefined ? null : response;
  }
  return response === '' ? null : JSON.parse(response);
}

function reasonFrom(text) {
  try {
    const body = parseJson(text);
    return (body && (body.Reason || body.reason)) || '';
  } catch (error) {
    // Kein JSON - etwa eine Fehlerseite des Gateways. Dann zaehlt der Status.
    return '';
  }
}

/** Uebersetzt eine Fehlerantwort in einen Satz fuer die Oberflaeche. */
export function failureMessage(status, body, fallback) {
  if (status === 503) {
    return BROKER_UNAVAILABLE;
  }
  if (status === 401) {
    return SESSION_EXPIRED;
  }
  if (status === 400) {
    return reasonFrom(body) || fallback;
  }
  return status ? `${fallback} (HTTP ${status})` : fallback;
}

// reqwest liefert ein eigenes Thenable, dessen then() nicht verkettet. Erst
// als Promise laesst sich das Ergebnis weiterreichen.
function request(method, url, data) {
  return new Promise((resolve, reject) => {
    reqwest({ method, url, data: { Token: token(), ...data } }).then(
      resolve,
      reject,
    );
  }).then(parseJson);
}

export function loadCatalog() {
  return request('get', settings.statisticEvaluation.getCatalog);
}

export function evaluate(definition) {
  return request('post', settings.statisticEvaluation.evaluate, {
    Definition: JSON.stringify(definition),
  });
}

export function loadSavedDefinitions() {
  return request('get', settings.statisticEvaluation.getSaved);
}

export function saveDefinition(savedStatistic) {
  return request('post', settings.statisticEvaluation.save, {
    SavedStatistic: JSON.stringify(savedStatistic),
  });
}

export function removeDefinition(guid) {
  return request('post', settings.statisticEvaluation.remove, { Guid: guid });
}

function fileNameFrom(disposition) {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition || '');
  return match
    ? decodeURIComponent(match[1])
    : `Statistik_${moment().format('YYYYMMDD')}.xlsx`;
}

function saveBlob(blob, fileName) {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}

export async function downloadExcel(definition) {
  const body = new FormData();
  body.append('Token', token() || '');
  body.append('Definition', JSON.stringify(definition));

  const response = await fetch(settings.statisticEvaluation.exportExcel, {
    method: 'POST',
    body,
  });
  const contentType = response.headers.get('content-type') || '';

  // Eine Fehlerantwort darf nie als .xlsx gespeichert werden; der Statistik
  // Export hat frueher die HTML-Fehlerseite als Datei abgelegt.
  if (!response.ok) {
    const text = response.text ? await response.text() : '';
    throw new Error(
      failureMessage(
        response.status,
        text,
        'Der Server hat die Excel-Datei nicht erstellt.',
      ),
    );
  }
  if (contentType.includes('text/html')) {
    throw new Error(
      'Der Server hat eine Fehlerseite statt einer Excel-Datei geliefert.',
    );
  }

  const blob = await response.blob();
  saveBlob(blob, fileNameFrom(response.headers.get('content-disposition')));
}
